import React from 'react';
import { createRoot } from 'react-dom/client';

import 'react-toastify/dist/ReactToastify.css';
import './alerts.css';
import './index.css';

import App from './components';
import MomentUtils from '@date-io/moment';
import ruLocale from 'date-fns/locale/ru';
import 'moment/locale/ru';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AuthProvider } from './contexts/AuthContext';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <LocalizationProvider
    utils={MomentUtils}
    dateAdapter={AdapterDateFns}
    adapterLocale={ruLocale}
  >
    <AuthProvider>
      <App />
    </AuthProvider>
  </LocalizationProvider>
);
